<div class="drill-down-wrapper" [style.height]="containerHeight">
  <div class="dd-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="dd-toolbar" *ngIf="!isLoading && flattenedRows.length">
    <button type="button" class="dd-tool-btn" (click)="expandAll()" matTooltip="Expand all">
      <mat-icon>unfold_more</mat-icon>
    </button>
    <button type="button" class="dd-tool-btn" (click)="collapseAll()" matTooltip="Collapse all">
      <mat-icon>unfold_less</mat-icon>
    </button>
  </div>

  <div class="dd-scroll" *ngIf="!isLoading && flattenedRows.length; else emptyState">
    <table class="dd-table">
      <thead>
        <tr>
          <th class="dd-label-header" [class.column-divider]="showDivider(labelColumn)">
            {{ labelFor(labelColumn) }}
          </th>
          <th *ngFor="let m of measureColumns" class="dd-measure-header"
            [class.column-divider]="showDivider(m)">
            {{ labelFor(m) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of flattenedRows"
          class="dd-row"
          [class.dd-selected]="isRowSelected(row)"
          [class.dd-has-children]="row.hasChildren"
          (click)="onRowClick(row)">
          <td class="dd-label-cell" [class.column-divider]="showDivider(labelColumn)">
            <div class="dd-label-content" [style.padding-left]="getIndentPadding(row.depth)">
              <mat-icon *ngIf="row.hasChildren" class="dd-toggle"
                (click)="toggleExpand(row, $event)">
                {{ row.expanded ? 'remove_circle_outline' : 'add_circle_outline' }}
              </mat-icon>
              <span class="dd-toggle-placeholder" *ngIf="!row.hasChildren"></span>
              <span class="dd-label-text" [title]="row.name">{{ row.name }}</span>
            </div>
          </td>
          <td *ngFor="let m of measureColumns" class="dd-measure-cell"
            [class.column-divider]="showDivider(m)">
            {{ formatMeasure(row.values[m]) }}
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="measureColumns.length">
        <tr class="dd-total-row">
          <td class="dd-label-cell dd-total-label">Total</td>
          <td *ngFor="let m of measureColumns" class="dd-measure-cell dd-total-cell">
            {{ formatMeasure(grandTotals[m]) }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="dd-empty" *ngIf="!isLoading">No data available.</div>
  </ng-template>
</div>
